<template>
  <div class="mb-5 mt-3">
    <h1>Választható csomagok</h1>
    <div>
      <label class="col-sm-4"
        >Kérjük, válassza ki a csomagot:
        <span class="text-danger">*</span></label
      >
      <div class="row justify-content-center">
        <PackageCard
          v-for="key in orderedAvailablePackages"
          :key="packageInfo[key].sorrend"
          :packageName="packageInfo[key].nev"
          :basePrice="packagePrices[key]"
          :packageDetails="availablePackages[key]"
          :packageCode="key"
          :recommended="packageInfo[key].kiemelt"
        />
      </div>
      <div v-show="false">
        <ValidationProvider
          rules="required"
          v-slot="{ errors, classes }"
          class="col-sm-8"
        >
          <input
            class="form-control"
            type="text"
            name="valasztott_csomag"
            id="valasztott_csomag"
            v-model="chosenPackage"
            :class="classes"
          />
          <small
            id="valasztott_csomag-errors"
            class="text-danger input-alert"
            >{{ errors[0] }}</small
          >
        </ValidationProvider>
      </div>
    </div>
    <h1>Választható Kiegészítő Fedezetek</h1>
    <div v-if="chosenPackage !== ''" class="row p-3 mb-5">
      <div
        v-if="
          this.recommendedValaszthatoKiegeszitok.length > 0 &&
            this.merchant_id === this.default_id
        "
        class="recommended-accessories-container"
      >
        <h2 class="text-center">Kiemelt választható kiegészítők</h2>
        <div
          class="col-12 mb-3"
          v-for="key in recommendedValaszthatoKiegeszitok"
          :key="key"
        >
          <BaseAccessory :aKey="key" :selectable="true" />
        </div>
      </div>
      <div
        class="col-12 mb-3"
        v-for="key in orderedValaszthatoKiegeszitok"
        :key="key"
      >
        <BaseAccessory :aKey="key" :selectable="true" />
        <!-- <Accesory :accesory="accesory" :aKey="key" :selectable="true" /> -->
      </div>
    </div>
    <div v-else class="row p-3 mb-5">
      <h2>Válasszon egy csomagot a kiegészítő fedezetek megjelenítéséhez!</h2>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import Accesory from "./components/Accesory";
import PackageCard from "./components/PackageCard.vue";
import { mapActions } from "vuex/dist/vuex.common.js";
import BaseAccessory from "./components/BaseAccessory.vue";
import _ from "lodash";

export default {
  components: {
    Accesory,
    PackageCard,
    BaseAccessory,
  },
  computed: {
    ...mapFields([
      "generalInfo.contractFor",
      "generalInfo.propertyInhabitated",
      "insuranceProperty.chosenInsurancePrice",
      "insurancePersonalGoods.calculatedInsurancePrice",
      "insurancePersonalGoods.acceptCalculatedInsurance",
      "insurancePersonalGoods.allGoodsPrice",
      "chooseableAccesories.valuablesAboveInputs",
      "availablePackages",
      "chosenPackage",
      "valaszthatoKiegeszitok",
      "packagePrices",
      "packageInfo",
      "chosenAccessories",
      "maxertekek",
      "merchant_id",
      "default_id",
    ]),
    ...mapFields({
      sideBuildings: "insuranceSideBuildings.list",
      accesoriesList: "chooseableAccesories.selectableList",
    }),
    accesoryList: function() {
      let showable = {};
      let notShowable = {};

      Object.entries(this.accesoriesList).forEach((accesory) => {
        if (accesory[1]?.showable?.includes(this.contractFor)) {
          showable[accesory[0]] = accesory[1];
        } else {
          notShowable[accesory[0]] = accesory[1];
        }

        if (accesory[1]?.onlyLiving === true && !this.propertyInhabitated) {
          if (accesory[0] in showable) {
            delete showable[accesory[0]];
            notShowable[accesory[0]] = accesory[1];
          }
        }
      });

      return {
        showable: showable,
        notShowable: notShowable,
      };
    },
    orderedAvailablePackages: function() {
      return _.sortBy(
        Object.keys(this.availablePackages),
        (item) => this.packageInfo[item].sorrend,
      );
    },
    orderedValaszthatoKiegeszitok: function() {
      let filteredValaszthatoKiegeszitok = Object.keys(
        this.valaszthatoKiegeszitok[this.chosenPackage],
      ).filter(
        (i) => !_.isArray(this.valaszthatoKiegeszitok[this.chosenPackage][i]),
      );

      if (this.merchant_id === this.default_id) {
        filteredValaszthatoKiegeszitok = filteredValaszthatoKiegeszitok.filter(
          (i) => !this.valaszthatoKiegeszitok[this.chosenPackage][i].kiemelt,
        );
      }

      return _.sortBy(
        filteredValaszthatoKiegeszitok,
        (item) =>
          this.valaszthatoKiegeszitok[this.chosenPackage][item]?.sorrend,
      );
    },
    recommendedValaszthatoKiegeszitok: function() {
      return Object.keys(
        this.valaszthatoKiegeszitok[this.chosenPackage],
      ).filter(
        (i) =>
          !_.isArray(this.valaszthatoKiegeszitok[this.chosenPackage][i]) &&
          this.valaszthatoKiegeszitok[this.chosenPackage][i].kiemelt,
      );
    },
  },
  methods: {
    ...mapActions([""]),
  },
  watch: {
    chosenPackage() {
      if (this.chosenPackage) {
        this.$store.dispatch("getMarks");
      }
    },
  },
};
</script>
<style>
.recommended-accessories-container {
  background-color: #006a52;
  margin-bottom: 3rem;
  padding: 2rem !important;
  border-radius: 1rem;
  box-shadow: 5px 5px 15px 8px rgb(209, 207, 207);
  border: 3px solid #00ab8e;
}

.recommended-accessories-container > h2 {
  color: white;
  text-shadow: 1px 1px 2px gray;
  font-size: 1.35rem !important;
}
</style>
